import Icon from '@loggi/ui/components/icon';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import React from 'react';
import styles from './can-not-edit-message.styles.scss';

export const CAN_NOT_EDIT_ADDRESS_MESSAGE =
  'A gente não consegue mais alterar o endereço por aqui, mas não se preocupe, entre em contato com a loja e altere seu endereço.';

export default function CanNotEditMessage() {
  return (
    <View className={styles.canNotEditContainer}>
      <Icon type={icons.type.INFO} color={colors.type.STORM_700} />
      <Text color={colors.type.SMOKE_900} size="200">
        {CAN_NOT_EDIT_ADDRESS_MESSAGE}
      </Text>
    </View>
  );
}
